import actions from "@iso/redux/aiCheckHistory/actions";

const initialState = {
  checkJobs: [],
  total: 0,
  loading: true,
  creating: false,
  normalizing: false,
};

export default function aiCheckHistoryReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_AI_CHECK_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_AI_CHECK_LIST_SUCCESS:
      return {
        ...state,
        checkJobs: action.checkJobs,
        total: action.total,
        loading: false,
      };
    case actions.GET_AI_CHECK_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case actions.CREATE_AI_CHECK_REQUEST:
      return {
        ...state,
        creating: true,
      };
    case actions.CREATE_AI_CHECK_SUCCESS:
    case actions.CREATE_AI_CHECK_ERROR:
      return {
        ...state,
        creating: false,
      };
    case actions.NORMALIZE_AI_CHECK_REQUEST:
      return {
        ...state,
        normalizing: true,
      };
    case actions.NORMALIZE_AI_CHECK_SUCCESS:
    case actions.NORMALIZE_AI_CHECK_ERROR:
      return {
        ...state,
        normalizing: false,
      };
    default:
      return state;
  }
}
